import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import config from '../../config';
import AnalyticsActionCreator from '../../actions/AnalyticsActionCreator';
import SpendingsActionCreator from '../../actions/SpendingsActionCreator';
import SpendingsStore from '../../stores/SpendingsStore';
import NumberUtils from '../../utils/NumberUtils';
import BrowserUtils from '../../utils/BrowserUtils';
import { SpendingsCreateBudgetDataGrid } from './SpendingsCreateBudgetDataGrid';
import { CreateBudgetProgress } from './CreateBudgetProgress';
import { CreateBudgetMessage } from './CreateBudgetMessage';
import { CreateBudgetHeaderMobile } from './CreateBudgetHeader_Mobile';
import SiteHeaderActionCreator from '../../actions/SiteHeaderActionCreator';

/**
 * @todo
 * The quality of this component could be improved.
 * Future improvement work could refactor this to increase the quality of the
 * codebase and make it easier to maintain and improve.
 */
class SpendingsCreateBudget extends Component {
  constructor(props) {
    super(props);

    this._addclassname = this._addclassname.bind(this);
    this._handleCancel = this._handleCancel.bind(this);
    this._handleEarnings = this._handleEarnings.bind(this);
    this._handleSave = this._handleSave.bind(this);
    this._loadSpendingAction = this._loadSpendingAction.bind(this);
    this._onChildToggle = this._onChildToggle.bind(this);
    this._removeclassname = this._removeclassname.bind(this);

    this.state = {
      pot: props.potValue,
      selections: [],
      tableData: SpendingsStore.newCreateBudgetData(),
      isSavEnable: false,
      budgetPacket: null,
      changeText: null,
    };
  }

  componentWillMount() {
    BrowserUtils.isMobileView() && SiteHeaderActionCreator.hideHeaderFlag(true);
    const data = {
      tag_budgets: [],
      category_budgets: [],
    };
    _.map(this.state.tableData, (item) => {
      if (item.key !== 'spend_pot_key') {
        if (item.tag_budget) {
          const obj = {
            tag_id: item.key,
            target_amount: {
              value: item.target_amount,
              currency: 'GBP',
            },
          };
          data.tag_budgets.push(obj);
        }
        if (item.category_budgets) {
          const obj = {
            category_id: item.key,
            target_amount: {
              value: item.target_amount,
              currency: 'GBP',
            },
          };
          data.category_budgets.push(obj);
        }
      }
    });
    // PB5007764 added last_month sorting for BOW-1017
    const forLastMonthData = this.state.tableData;
    let sortedLastMonthTableData;
    _.map(forLastMonthData, (item) => {
      if (item.last_month) {
        item.last_month = Number(Math.abs(item.last_month));
      }
    });
    sortedLastMonthTableData = _.sortBy(forLastMonthData, ['last_month']);
    sortedLastMonthTableData.reverse();
    // PB5007764 End.
    this.setState({ budgetPacket: data, tableData: sortedLastMonthTableData });
  }

  componentDidMount() {
    // Record an analytics user event.
    AnalyticsActionCreator.track(
      {
        path: '/user/experience/view',
        action: 'Appeared',
      },
      {
        description: config.analytics.analytics_name_budget,
      }
    );
  }

  componentWillUnmount() {
    SiteHeaderActionCreator.hideHeaderFlag(false);
  }

  _addclassname() {
    this.setState({ changeText: 'expand-look' }, () => {});
  }

  _handleCancel() {
    SiteHeaderActionCreator.hideHeaderFlag(false);
    this._loadSpendingAction();
    if (BrowserUtils.isMobileView()) {
      SpendingsActionCreator.checkScreenFlag(0);
    }
  }

  _handleEarnings() {
    // Record an analytics user event.
    AnalyticsActionCreator.track(
      {
        path: '/user/experience/activity',
        action: 'Interacted',
      },
      {
        description: config.analytics.analytics_name_budget_income,
        event: 'click',
      }
    );
    const myList = this.state.tableData;
    const budgetPacket = [];
    _.map(this.state.budgetPacket.category_budgets, (item) =>
      budgetPacket.push(item)
    );
    _.map(this.state.budgetPacket.tag_budgets, (item) =>
      budgetPacket.push(item)
    );

    const newObj = [];
    _.map(myList, (items) => {
      let target_amount = items.target_amount;
      _.map(budgetPacket, (item) => {
        if (items.key === item.category_id) {
          target_amount = item.target_amount.value;
        }
        if (items.key === item.tag_id) {
          target_amount = item.target_amount.value;
        }
      });
      let obj = [];
      if (items.key === 'spend_pot_key') {
        obj = items;
      } else {
        obj = {
          archived: items.archived,
          category_budgets: items.category_budgets,
          joint: items.joint,
          key: items.key,
          last_month: items.last_month,
          name: items.name,
          tag_budget: items.tag_budget,
          target_amount,
        };
      }
      newObj.push(obj);
    });
    SpendingsActionCreator.handleUpdatedBudgetData(newObj);
    SpendingsActionCreator.loadEarningPage(3);
  }

  _handleSave() {
    const requestData = {
      budgetPacket: this.state.budgetPacket,
      earnings: this.props.earnings,
    };
    SpendingsActionCreator.updatePreferencesAndBudgetConnection(requestData);
    // if (!_.isEmpty(this.props.earnings)) {
    //   SpendingsActionCreator.updateBudgetPreferencesConnection(this.props.earnings);
    // }
    // this._loadSpendingAction();
    if (BrowserUtils.isMobileView()) {
      SpendingsActionCreator.checkScreenFlag(0);
    }
  }

  _loadSpendingAction() {
    // Get Account List
    SpendingsActionCreator.getAccountsList();
    SpendingsActionCreator.getBudgetConnection();
    SpendingsActionCreator.getTagListConnection();
    SpendingsActionCreator.getBudgetPreferencesConnection();
  }

  _onChildToggle(id, selected) {
    const selections = this.state.selections;
    const list = this.state.tableData;
    const sortedTableData = this.state.tableData;
    const budgetPacketList = this.state.budgetPacket;
    selections[id] = selected;
    this.setState({ isSavEnable: true });

    _.map(budgetPacketList.category_budgets, (item) => {
      let tAmount;
      _.map(list, (item) => {
        if (item.key === id) {
          tAmount = item.target_amount;
        }
      });
      if (item.category_id === id) {
        item.target_amount.value = tAmount + selections[id];
      }
    });
    _.map(budgetPacketList.tag_budgets, (item) => {
      let tAmount;
      _.map(list, (item) => {
        if (item.key === id) {
          tAmount = item.target_amount;
        }
      });
      if (item.tag_id === id) {
        item.target_amount.value = tAmount + selections[id];
      }
    });

    _.map(sortedTableData, (item) => {
      let myTAmount;
      _.map(budgetPacketList.category_budgets, (item) => {
        if (item.category_id === id) {
          myTAmount = item.target_amount.value;
        }
      });

      _.map(budgetPacketList.tag_budgets, (item) => {
        if (item.tag_id === id) {
          myTAmount = item.target_amount.value;
        }
      });

      if (item.key === id) {
        item.target_amount = myTAmount;
      }
    });
    this.setState({
      budgetPacket: budgetPacketList,
      tableData: sortedTableData,
    });
  }

  _removeclassname() {
    this.setState({ changeText: null });
  }

  render() {
    const changeText = this.state.changeText;
    const tableData = this.state.tableData;
    const content = this.props.content;
    let earning;
    let createEditBudgetTittle;

    if (!_.isEmpty(this.props.earnings)) {
      earning = this.props.earnings.period.net_income.value;
    } else {
      earning = 0;
    }
    let headerLeftMessage = content.spendingCreateHeaderLeftLabel;

    const targetAmount = [];
    _.map(this.state.budgetPacket.category_budgets, (item) =>
      targetAmount.push(item.target_amount.value)
    );
    _.map(this.state.budgetPacket.tag_budgets, (item) =>
      targetAmount.push(item.target_amount.value)
    );

    const totalTargetAmount = _.sum(targetAmount);
    const totalBudgetValue = totalTargetAmount + this.state.pot;

    let noPotClass;
    if (this.state.pot === 0) {
      headerLeftMessage = content.spendingTableHeaderText8;
      noPotClass = 'no-pot';
    }
    let savebutton;
    if (earning !== 0) {
      savebutton = (
        <button
          type="button"
          className="btn btn-link btn-style"
          onClick={this._handleSave}
        >
          {content.spendingSaveButtonText}
        </button>
      );
    }

    let createBudgetDesktop;
    let createBudgetMobile;
    if (!BrowserUtils.isMobileView()) {
      createBudgetDesktop = (
        <div className="main-container spending-edit">
          <div className="headerRow row no-gutters">
            <div className="col-xs-2 text-left">
              <button
                type="button"
                className="btn btn-link btn-style"
                onClick={this._handleCancel}
              >
                {content.spendingCancelButtonText}
              </button>
            </div>
            <div className="col-xs-8" />
            <div className="col-xs-2 text-right">{savebutton}</div>
          </div>
          <div className="spendings-progress">
            <div className="budget-status">
              <div className="monthly-progress row">
                <div className="col-xs-3">
                  <h6>{headerLeftMessage}</h6>
                  <h2>{NumberUtils.appendCurrency('{}', totalBudgetValue)}</h2>
                </div>
                <div className="col-xs-6 text-center">
                  <CreateBudgetProgress
                    content={content}
                    totalBudgetValue={totalBudgetValue}
                    potValue={this.state.pot}
                    earning={earning}
                  />
                </div>
                <div className="col-xs-3">
                  <h6>{content.spendingCreateHeaderRightLabel}</h6>
                  <h2>{NumberUtils.appendCurrency('{}', earning)}</h2>
                </div>
              </div>
              <div className="edit-earning">
                <a
                  className="page-option icon icon-edit"
                  onClick={this._handleEarnings}
                />
              </div>
            </div>
          </div>
          <div className={`edit-budget scroll-wrapper ${noPotClass}`}>
            <div className="edit-budget-grid content-wrapper">
              <div className="row ">
                <div className="col-xs-7">
                  <SpendingsCreateBudgetDataGrid
                    content={content}
                    tableData={tableData}
                    customClick={this._onChildToggle}
                  />
                </div>
                <div className="col-xs-5">
                  <CreateBudgetMessage
                    content={content}
                    totalBudgetValue={totalBudgetValue}
                    potValue={this.state.pot}
                    earning={earning}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      const allBudgetTarget = _.sum(this.props.allBudgetTarget);
      if (allBudgetTarget <= 0) {
        createEditBudgetTittle = (
          <div>{content.spendingHeaderButtonLabel2}</div>
        );
      } else {
        createEditBudgetTittle = (
          <div>{content.spendingHeaderButtonLabel3}</div>
        );
      }
      createBudgetMobile = (
        <div className="main-container from-top edit-create-budget">
          <div className="headerRow row no-gutters">
            <div className="col-xs-6 text-left">
              <button
                type="button"
                className="btn btn-link btn-style"
                onClick={this._handleCancel}
              >
                {content.spendingCancelButtonText}
              </button>
            </div>
            <div className="col-xs-6 text-right">{savebutton}</div>
            <div className="col-xs-12 text-center">
              <h5>{createEditBudgetTittle}</h5>
            </div>
          </div>
          <CreateBudgetHeaderMobile
            content={content}
            totalBudgetValue={totalBudgetValue}
            potValue={this.state.pot}
            earning={earning}
            _handleEarnings={this._handleEarnings}
            _addclassname={this._addclassname}
            _removeclassname={this._removeclassname}
          />
          <div className={`${changeText}`}>
            <SpendingsCreateBudgetDataGrid
              content={content}
              tableData={tableData}
              customClick={this._onChildToggle}
            />
          </div>
        </div>
      );
    }

    return BrowserUtils.isMobileView() ? (
      <div>{createBudgetMobile}</div>
    ) : (
      <div className="full-height">{createBudgetDesktop}</div>
    );
  }
}

SpendingsCreateBudget.propTypes = {
  content: PropTypes.object,
  earnings: PropTypes.object,
  potValue: PropTypes.number,
  allBudgetTarget: PropTypes.object,
};

export { SpendingsCreateBudget };
